import React, { useRef, useState } from "react";
import useInvitations from "../hooks/useInvitations";
import Box from "./Box";

const UPLOAD_URL = "https://poster-2020-api.herokuapp.com/upload";

export default function SubmitBox() {
  const { user } = useInvitations();

  const [state, setState] = useState({
    error: "",
    submitting: false,
    success: false,
  });

  const inputRef = useRef(null);
  function handleSubmit(e) {
    e.preventDefault();
    if (inputRef.current && !state.submitting) {
      const files = inputRef.current.files;
      if (files.length > 0) {
        const file = files[0];
        const formData = new FormData();
        formData.append("invitationId", user.id);
        formData.append("image", file);
        setState({
          error: "",
          submitting: true,
          success: false,
        });
        fetch(UPLOAD_URL, {
          method: "POST",
          body: formData,
        })
          .then(() => {
            setState({
              error: "",
              submitting: false,
              success: true,
            });
          })
          .catch((err) => {
            console.error(err);
            setState({
              error: "something went wrong 😬 try again?",
              submitting: false,
              success: false,
            });
          });
      }
    }
  }

  if (!user) {
    return (
      <Box
        title="IMAGE SUBMISSION ZONE"
        backgroundColor="lightsalmon"
        borderColor="aquamarine"
      >
        You can't submit an image unless you've got an invitation. Use the
        invitation link Frank gave you to "sign in".
      </Box>
    );
  }

  return (
    <Box
      title="IMAGE SUBMISSION ZONE"
      backgroundColor="lightsalmon"
      borderColor="aquamarine"
    >
      <div style={{ marginBottom: "1rem" }}>
        {user.square ? (
          <>
            Your submission is in square #{user.square}!
            <br />
            <br />
            You can change your image by resubmitting.
          </>
        ) : (
          <>
            Submit ASAP to claim a square because I will be sending out more
            than 72 invitations this year.
            <br />
            <br />
            You can change your image later by resubmitting.
          </>
        )}
      </div>
      <form
        onSubmit={handleSubmit}
        style={{ display: "flex", alignItems: "center" }}
      >
        <input
          style={{
            width: "100%",
            background: "rgba(0,0,0,0.1)",
            padding: "1rem",
          }}
          accept=".jpg,.jpeg,.png"
          ref={inputRef}
          type="file"
        ></input>
        <button
          disabled={state.submitting}
          type="submit"
          style={{
            padding: "0.95em 1em",
            marginLeft: "1rem",
          }}
        >
          {state.submitting ? "Submitting..." : "Submit!"}
        </button>
      </form>
      {state.success && (
        <div
          style={{
            textAlign: "center",
            marginTop: "1rem",
            background: "lightgreen",
            padding: "1rem",
          }}
        >
          Huge Success! Thanks for the image!
          <br />
          It will take a few moments for the poster to update.
        </div>
      )}
      {state.error && (
        <i style={{ textAlign: "center", padding: "1rem" }}>{state.error}</i>
      )}
    </Box>
  );
}
